import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/navbar/index.jsx';
import Footer from '../../components/Footer/Footer.js';
import WaFloat from '../../components/WaFloat/WaFloat.jsx';
import { useReveal } from '../../hooks/useReveal.js';

const whoFor = [
  { h: 'High Net Worth Individuals', p: "Individuals seeking structured, advisory-led access to private investment opportunities in India's growth businesses." },
  { h: 'Family Offices', p: 'Single and multi-family offices seeking differentiated deal flow with institutional-grade documentation and process.' },
  { h: 'Angel Networks', p: 'Organised angel groups looking for later-stage, revenue-generating businesses with clear growth trajectories.' },
  { h: 'UHNI & Promoter Investors', p: 'Experienced investors seeking to co-invest in sectors they understand, with an expert advisory team managing the process.' },
];

const whatYouAccess = [
  { h: 'Equity opportunities', p: 'Growth equity and pre-expansion businesses raising capital. Strong fundamentals, documented growth plans, advisory-prepared.' },
  { h: 'Debt introductions', p: "Asset-backed businesses seeking structured debt. Collateral documented, financial structure assessed by AQT Direct's advisory team." },
  { h: 'Strategic stakes', p: 'Minority positions in sector-leading mid-market businesses. Often includes governance rights and structured protection terms.' },
  { h: 'Co-investment', p: 'Participate alongside anchor investors in larger opportunities. Lower minimum ticket, same terms, same due process.' },
];

export default function Investors() {
  useReveal();
  return (
    <>
      <Navbar />

      {/* DARK HERO */}
      <div className="page-hero-dark">
        <div className="page-hero-dark-img">
          <img
            src="https://images.unsplash.com/photo-1560472354-b33ff0c44a43?auto=format&fit=crop&w=900&q=80"
            alt="Investors in a business meeting"
          />
        </div>
        <div className="page-hero-inner">
          <span className="sec-tag reveal">Investor Network</span>
          <h2 className="sec-h reveal" style={{ maxWidth: 600 }}>
            Private access to<br />India's most <em>curated opportunities.</em>
          </h2>
          <p className="sec-sub reveal reveal-delay-1">
            AQT Direct's investor network provides structured access to assessed, advisory-led business opportunities in India's mid-market. Confidential. Curated. Institutional in process.
          </p>
          <div className="reveal reveal-delay-2" style={{ marginTop: 32 }}>
            <Link className="btn-white-outline" to="/contactus">Register Interest</Link>
          </div>
        </div>
      </div>

      <hr className="rule" />

      {/* WHO IT'S FOR */}
      <section className="section">
        <span className="sec-tag reveal">Who this is for</span>
        <div className="inv-grid reveal">
          {whoFor.map(({ h, p }) => (
            <div className="inv-tile" key={h}><h4>{h}</h4><p>{p}</p></div>
          ))}
        </div>
      </section>

      <hr className="rule" />

      {/* WHAT YOU ACCESS */}
      <section className="section section-off">
        <span className="sec-tag reveal">What you access</span>
        <h2 className="sec-h reveal" style={{ maxWidth: 480 }}>
          Structured opportunities.<br /><em>Assessed before you see them.</em>
        </h2>
        <div className="inv-grid reveal reveal-delay-1">
          {whatYouAccess.map(({ h, p }) => (
            <div className="inv-tile" key={h}><h4>{h}</h4><p>{p}</p></div>
          ))}
        </div>
        <p className="inv-note reveal reveal-delay-2">
          AQT Direct provides advisory and investor-connect services only. All investment decisions are made independently by investors with their own advisors. This is not an offer or solicitation of any kind.
        </p>
      </section>

      <div className="cta-strip reveal">
        <h2>Access is by introduction<br /><em>or direct request.</em></h2>
        <p>Register your investment profile and we will be in touch when an opportunity matching your criteria becomes available.</p>
        <div className="cta-btns">
          <Link className="btn-white" to="/contactus">Register Interest</Link>
        </div>
      </div>

      <Footer />
      <WaFloat />
    </>
  );
}
